import type { ComponentType } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MessageIcon from '@mui/icons-material/Message';
import TimelineIcon from '@mui/icons-material/Timeline';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import MapIcon from '@mui/icons-material/Map';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsIcon from '@mui/icons-material/Settings';
import HubIcon from '@mui/icons-material/Hub';
import type { SvgIconProps } from '@mui/material';
import { Permission } from '@k-ucap/shared';
import { DashboardPage } from '@/pages/DashboardPage/DashboardPage.js';
import { GeneratorPage } from '@/pages/GeneratorPage/GeneratorPage.js';
import { ScenarioPage } from '@/pages/ScenarioPage/ScenarioPage.js';
import { AnalyzerPage } from '@/pages/AnalyzerPage/AnalyzerPage.js';
import { GisPage } from '@/pages/GisPage/GisPage.js';
import { MessagesPage } from '@/pages/MessagesPage/MessagesPage.js';
import { ReportsPage } from '@/pages/ReportsPage/ReportsPage.js';
import { SettingsPage } from '@/pages/SettingsPage/SettingsPage.js';
import { IntegrationPage } from '@/pages/IntegrationPage/IntegrationPage.js';

export interface AppRoute {
  path: string;
  label: string;
  icon: ComponentType<SvgIconProps>;
  requiredPermission: Permission | null;
  requiresProject: boolean;
  showInMenu: boolean;
  order: number;
  component: ComponentType;
}

export const appRoutes: AppRoute[] = [
  {
    path: '/dashboard',
    label: '대시보드',
    icon: DashboardIcon,
    requiredPermission: null,
    requiresProject: false,
    showInMenu: true,
    order: 1,
    component: DashboardPage,
  },
  {
    path: '/generator',
    label: '메시지 생성기',
    icon: MessageIcon,
    requiredPermission: Permission.MESSAGE_GENERATE,
    requiresProject: false,
    showInMenu: true,
    order: 2,
    component: GeneratorPage,
  },
  {
    path: '/scenario',
    label: '시험 시나리오',
    icon: TimelineIcon,
    requiredPermission: Permission.SCENARIO_VIEW,
    requiresProject: true,
    showInMenu: true,
    order: 3,
    component: ScenarioPage,
  },
  {
    path: '/analyzer',
    label: '메시지 분석기',
    icon: AnalyticsIcon,
    requiredPermission: Permission.MESSAGE_ANALYZE,
    requiresProject: false,
    showInMenu: true,
    order: 4,
    component: AnalyzerPage,
  },
  {
    path: '/gis',
    label: 'GIS 전시기',
    icon: MapIcon,
    requiredPermission: Permission.GIS_VIEW,
    requiresProject: false,
    showInMenu: true,
    order: 5,
    component: GisPage,
  },
  {
    path: '/messages',
    label: '메시지 로그',
    icon: ListAltIcon,
    requiredPermission: Permission.MESSAGE_EVENT_VIEW,
    requiresProject: false,
    showInMenu: true,
    order: 6,
    component: MessagesPage,
  },
  {
    path: '/reports',
    label: '보고서',
    icon: AssessmentIcon,
    requiredPermission: Permission.REPORT_VIEW,
    requiresProject: false,
    showInMenu: true,
    order: 7,
    component: ReportsPage,
  },
  {
    path: '/integration',
    label: '연동 관리',
    icon: HubIcon,
    requiredPermission: Permission.INTEGRATION_VIEW,
    requiresProject: false,
    showInMenu: true,
    order: 8,
    component: IntegrationPage,
  },
  {
    path: '/settings',
    label: '설정',
    icon: SettingsIcon,
    requiredPermission: Permission.SETTINGS_VIEW,
    requiresProject: false,
    showInMenu: true,
    order: 9,
    component: SettingsPage,
  },
];

export const menuRoutes = appRoutes.filter((route) => route.showInMenu).sort((a, b) => a.order - b.order);

export const getRouteByPath = (path: string): AppRoute | undefined => appRoutes.find((route) => route.path === path);
